import(/* webpackMode: "eager" */ "/vercel/path0/src/app/gift/page.tsx");
